import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./redux/ConfigureStore.js";
import App from "./App";

import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/material-kit-react.scss?v=1.9.0";

const store = configureStore();
var hist = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>
    <Router history={hist} basename="/">
      <App />
    </Router>
  </Provider>,
  document.getElementById("root")
);
